import React, { Component } from 'react'
import { connect } from 'react-redux'
import DeviceSelectModal from '../../components/DeviceSelectModal/DeviceSelectModal'
import {
  selectDevices,
  selectDeviceManufacturers,
  selectDeviceSoftware
} from './selectors'
import { createEvent } from '../UserEvents/actions'

class DeviceSelectorContainer extends Component {
  render() {
    const {
      devices,
      show,
      setDevice,
      manufacturers,
      deviceSoftware,
      createUserEvent,
      onHide
    } = this.props

    return (
      <DeviceSelectModal
        devices={devices}
        manufacturers={manufacturers}
        deviceSoftware={deviceSoftware}
        show={show}
        setDevice={setDevice}
        createUserEvent={createUserEvent}
        onHide={onHide}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  devices: selectDevices(state),
  manufacturers: selectDeviceManufacturers(state),
  deviceSoftware: selectDeviceSoftware(state),
  onHide: ownProps.onHide
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceSelectorContainer)



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/DeviceSelector.js